import React from "react";
import "../../Assets/Styles/pages/landing.scss";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const BlogsTitle = () => {
  const { t } = useTranslation();

  return (
    <Row className="m-0  p-0 w-100 d-flex justify-content-center ">
      <Row className=" text-center d-flex justify-content-center align-items-center">
        <p className="m-0 w_40 w-xs-100 px-5  text_40 productSansBold">
          <span>{t("blogsTitle")}</span>
          <span className="mx-2  landing_banner_Heading productSansBold">
            {t("blogsTitlespan")}
          </span>
        </p>
      </Row>
      <Row className="d-flex mt-3 justify-content-center">
        <p className="w_30 w-xs-90 mt-1 text-black productSansLight text-center text_18 px-3">
          {t("blogsSubTitle")}
        </p>
      </Row>
    </Row>
  );
};

export default BlogsTitle;
